import { createFileRoute } from '@tanstack/react-router'
import { JobConsolePage } from '@/features/jobs'

type JobConsoleSearch = {
  jobId?: number
  status?: string
  jobType?: string
  instanceId?: number
  q?: string
  tab?: 'overview' | 'active' | 'failed' | 'history'
  sortBy?: string
  sortDir?: 'asc' | 'desc'
}

export const Route = createFileRoute('/_authenticated/jobs/')({
  validateSearch: (search: Record<string, unknown>): JobConsoleSearch => {
    const rawJobId =
      search.jobId !== undefined && search.jobId !== null ? Number(search.jobId) : undefined
    const rawInstanceId =
      search.instanceId !== undefined && search.instanceId !== null
        ? Number(search.instanceId)
        : undefined
    return {
      jobId:
        typeof rawJobId === 'number' && Number.isFinite(rawJobId) ? rawJobId : undefined,
      status: typeof search.status === 'string' ? search.status : undefined,
      jobType: typeof search.jobType === 'string' ? search.jobType : undefined,
      instanceId:
        typeof rawInstanceId === 'number' && Number.isFinite(rawInstanceId)
          ? rawInstanceId
          : undefined,
      q: typeof search.q === 'string' ? search.q : undefined,
      tab:
        search.tab === 'overview' ||
        search.tab === 'active' ||
        search.tab === 'failed' ||
        search.tab === 'history'
          ? search.tab
          : undefined,
      sortBy: typeof search.sortBy === 'string' ? search.sortBy : undefined,
      sortDir:
        search.sortDir === 'asc' || search.sortDir === 'desc'
          ? search.sortDir
          : undefined,
    }
  },
  component: JobConsolePage,
})
